/**
 * withPoinstHistory
 * HOC for wrapping the provided component with LoyaltyPointTransactionsProvider
 */

import React from 'react'

import LoyaltyPointTransactionsProvider from './loyalty-point-transactions-provider'

export default function withLoyaltyPointTransactions (WrappedComponent) {
  return function LoyaltyPointTransactionsProviderHOC(props) {
    return (
      <LoyaltyPointTransactionsProvider>
        <WrappedComponent {...props} />
      </LoyaltyPointTransactionsProvider>
    )
  }
}
